import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import english from "flatpickr/dist/l10n/default.js"

const LOCALES = {
  'es-CL': Spanish,
  'en-US': english
}

export default class extends Controller {
  static targets = ["input"]
  static values = { options: Object }

  connect() {
    this.initializeTimepicker()
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
    }
  }

  initializeTimepicker() {
    const selectedLocale = LOCALES[this.optionsValue.locale]
    const config = {
      ...this.optionsValue,
      locale: selectedLocale
    }

    this.fp = flatpickr(this.inputTarget, config)
  }

  getDefaultHour() {
    const value = this.inputTarget.value
    if (!value) return null
    return parseInt(value.split(':')[0]) || null
  }

  getDefaultMinute() {
    const value = this.inputTarget.value
    if (!value) return null
    return parseInt(value.split(':')[1]) || null
  }

  clear() {
    if (this.fp) {
      this.fp.clear()
    }
  }
}
